import React, { useState, useEffect } from 'react'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import { doneLoading, startLoading } from '../../utils/loading'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import TempletDetailFormWidget from '../../widgets/projectProposal/TempletDetailFormWidget'
import { sessionGetItemStr } from '../../utils/sessionHelpers'
import { TEMP_FORM_ID } from '../../constants/constants'
import { getManageProposalFormById } from '../../redux/actions/subProjectFormSetting'

export default function TempletDetailForm() {
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()
  const [error, setError] = useState()

  const formId = sessionGetItemStr(TEMP_FORM_ID)

  useEffect(() => {
    if (formId) {
      handleGetSchema()
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await getManageProposalFormById(formId)
      // const _schema = mockSchema
      setSchema(_schema)
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isNewSubProjectSetting>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isNewSubProjectSetting>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isNewSubProjectSetting>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          {schema?.projectTemplete && <TempletDetailFormWidget schema={schema.projectTemplete} />}
        </SidebarProposal>
      )}
    </>
  )
}
